import Flickity from 'flickity/js/index';
import FlickityFade from 'flickity-fade/flickity-fade';
import * as ScrollLock from 'scroll-lock';
import SimpleParallax from "simple-parallax-js/vanilla";

window.theme = window.theme || {};
window.theme.Flickity = Flickity;
window.theme.FlickityFade = FlickityFade;
window.theme.ScrollLock = ScrollLock;
window.theme.SimpleParallax = SimpleParallax;
